module.exports = __webpack_public_path__ + "img/blue_053.6a046c6e.png";